import React from 'react';
import ProgressSpinner from '../material/ProgressSpinner';
import { get } from 'lodash';

export const renderContainerChildren = (props, style, WrapperComponent = React.Fragment) => {
  const { children, collection = [], currentEntity, isLoadingData, hideLoader } = props;
  const isCollectionEmpty = !collection.length;
  const isMemberSelected = !!currentEntity;
  let showLoading = false;
  const renderedChildren =  React.Children.map(children, child => {
    if (!child) {
      return null;
    }
    const { showIfCollectionEmpty, hideIfCollectionEmpty,
      showIfMemberSelected, hideIfMemberSelected,
      hideIfLoadingCollection, hideIfLoadingMember } = child.props || {};
    const isHidden = (
      (showIfCollectionEmpty && !isCollectionEmpty) ||
      (hideIfCollectionEmpty && isCollectionEmpty) ||
      (showIfMemberSelected && !isMemberSelected) ||
      (hideIfMemberSelected && isMemberSelected) ||
      (hideIfLoadingMember && isLoadingData) ||
      (hideIfLoadingCollection && isLoadingData && isCollectionEmpty)
    );

    if (isHidden) {
      showLoading = showLoading || isLoadingData;
      return (
        <div style={{ display: 'none' }}>
          {child}
        </div>
      );
    } else if (style) {
      const type = child.type;
      const name = (typeof type === 'string' ? type : type.name).toLowerCase();
      return <div style={style} className={`child-container-${name}`}>
        {child}
      </div>
    } else {
      return child;
    }
  });
  if (!renderedChildren || !renderedChildren.length) {
    return null;
  }
  return (
    <WrapperComponent>
      <>
        {renderedChildren}
        {showLoading && !hideLoader && <ProgressSpinner />}
      </>
    </WrapperComponent>
  );
};

export const renderFields = (props, renderWrapper) => {
  const { children, name, data, activeLanguage, onKeyDown, onValueChange,
    runValidation, scrollContainerId, valueChangeDelay, languages } = props;

  return React.Children.map(children, (child, index) => {
    if (child) {
      let dataValue;
      let fieldName = child.props.multilingual ? `${child.props.name}_${activeLanguage}` : child.props.name;
      if (name) {
        fieldName = `${name}[${fieldName}]`;
      }
      if(child.props.valueOverride && child.props.dataValue) {
        dataValue = child.props.dataValue;
      } else if (data) {
        dataValue = get(data, child.props.fieldName || fieldName);
      }

      const cloneProps = {
        dataValue: dataValue,
        onKeyDown: onKeyDown,
        onValueChange: onValueChange,
        valueChangeDelay: valueChangeDelay,
        runValidation: runValidation || child.props.runValidation,
        scrollContainerId: scrollContainerId,
        activeLanguage: activeLanguage,
        languages: languages,
        name: fieldName
      }
      if (data) {
        cloneProps.data = data;
      }

      const renderedChild = React.cloneElement(child, cloneProps);
      if (renderWrapper) {
        return renderWrapper(renderedChild, index);
      }
      return renderedChild;
    }
  });
};
